import React, { FC } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import Box from '@mui/material/Box';

import { Title } from 'ui';
import clsx from 'clsx';

type HeadSquareProps = {
  title?: string;
  subtitle?: string;
  subtitleTooltip?: string;
  customScore?: boolean;
};

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: customScore =>
      customScore ? theme.palette.custom.gray : theme.palette.primary.main,
    padding: theme.spacing(3, 1.5),
    color: '#fff',
    textAlign: 'center',
    minHeight: 180,
    height: '100%',
    flexDirection: 'column',
    position: 'relative',
  },
  customScore: {
    backgroundColor: theme.palette.custom.slightlyDesaturatedBlue,
  },
  title: {
    color: '#fff !important',
  },
  subtitle: {
    fontSize: '0.75rem',
  },
  white: {
    color: theme.palette.custom.white,
  },
}));
const HeadSquare: FC<HeadSquareProps> = ({
  title,
  subtitle,
  subtitleTooltip = '',
  customScore = false,
  children,
}) => {
  const classes = useStyles(customScore);

  return (
    <Box
      className={classes.root}
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      alignItems="center"
    >
      <Box height={20}>
        {title && (
          <Title className={classes.title} align="center">
            {title}
          </Title>
        )}
      </Box>

      <Box>{children}</Box>

      <Box height={20}>
        {subtitle && (
          <Title
            className={clsx(classes.title, classes.subtitle)}
            align="center"
            tooltip={subtitleTooltip}
            tooltipClassName={classes.white}
          >
            {subtitle}
          </Title>
        )}
      </Box>
    </Box>
  );
};

export default HeadSquare;
